export default __webpack_public_path__ + "static/media/secure.e73b821d.svg";